import React, { useState, useEffect, useContext, createContext } from "react";
import axios from "axios";

const HOST_ = window.location.hostname || "localhost";
const ENDPOINT = 'token'
const API_URL = `http://${HOST_}:9167`
const ENDPOINT_TOKEN = 'token'
const ENDPOINT_REGISTER = 'register'

const key_semidpairs = 'semidpairs';

// const UpdateContext = (reduced_payload: any) => {
  
//   // const { loading, loggedIn, roles, token, user } = useContext(AuthContext)
//   console.log('Ready to update Context')
//   try {
//     const SetUserPayload = useContext(AuthContext).login;
//       // Update context
//     SetUserPayload(reduced_payload)
    
//   } catch (error) {
//     console.log(error)
//   }
// }

const reduceApiPayload = (payload: any) => {
  /**
   * Expected Reduced Payload
   * - token
   * - user 
   * - first: string,
   * - last: string,
   * - roles: string[], //pi
   * - userid: string,
   * - allsemids: string[],
   * - semidpairs: string[],
   * - instruments: string
  */

  try {

    const userinfo_obj = JSON.parse(payload.user_payload.userinfo);

    const instr_ = payload.user_payload.semidpairs.map((x: string) => {
      return x.split(':')[1]
    });

    const semids_ = payload.user_payload.semidpairs.map((x: string) => {
      return x.split(':')[0]
    });
    
    let reduced_payload = {
      token: payload.token,
      user: {
        userid: userinfo_obj.userid,
        first: userinfo_obj.first,
        last: userinfo_obj.last,
        email: userinfo_obj.email,
        roles: userinfo_obj.roles,
        allsemids: payload.user_payload.all_semids,
        semidpairs: payload.user_payload.semidpairs,
        semids: semids_,
        instruments: instr_,
      }
    };

    return reduced_payload
  } catch (err) {
    console.log(`err while reducing`)
    console.log(err)
  }

}

export const register = (userid: string, email: string, password: string) => {
  return axios.post(API_URL + ENDPOINT_REGISTER, {
    userid,
    email,
    password,
  });
};


export const login_axios = async (userid: string, password: string) => {

  return axios
    .post(API_URL + ENDPOINT_TOKEN, {
      userid,
      password,
    })
    .then((response) => {
      if (response.data.token) {
        // Update authContext with User
        const reduced_data = reduceApiPayload(response.data)
        localStorage.setItem("obs_session", JSON.stringify(reduced_data));

        // Store Refresh token in desired location
        // console.log('Storing into localstorage token and refresh_token' )
        localStorage.setItem("refresh_token", JSON.stringify(response.data.refresh_token ? response.data.refresh_token : '---'));

        // console.log(localStorage);
        return {"error": false, "message": JSON.stringify(reduced_data)};
      }

    }).catch((err) => {
      console.error("Login Failed!!")
      return {"error": true, "message": 'Check your credentials or contact admin.'}
    });
};

export const logout_axios = () => {

  // Update authContext with User
  
  localStorage.removeItem("obs_session");
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem("obs_session");
  if (userStr) return JSON.parse(userStr);

  return null;
};

export const getAuthorizedSemids = () => {
  const userStr = localStorage.getItem("user");
  if (userStr)
    try {
      return JSON.parse(userStr)['user_payload']['semidpairs'];
    } catch (err) {
      console.log('Unable to find Authorized Semids for user.')
    }

  return null;
};
